export default __webpack_public_path__ + "static/media/60.18f20117.jpg";